import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseDto } from '../../../shared/modules/base/dtos/base.dto';
import { ThirdPartyContactDto } from '../../contacts/dtos/third-party-contact.dto';
import { RentalAgreementListDto } from '../../rental-agreements/dtos/rental-agreement-list.dto';
import { TagListDto } from '../../tags/dtos/tag-list.dto';
import { VehicleInsuranceClaimListDto } from '../../vehicle-insurance-claims/dtos/vehicle-insurance-claim-list.dto';
import { VehicleInsuranceListDto } from '../../vehicle-insurances/dtos/vehicle-insurance-list.dto';
import { VehicleListDto } from '../../vehicles/dtos/vehicle-list.dto';
import { VehicleDamageFaultEnum } from '../enums/vehicle-damage-fault.enum';
import { VehicleDamageRecordCategoryEnum } from '../enums/vehicle-damage-record-category.enum';
import { VehicleDamageSeverityEnum } from '../enums/vehicle-damage-severity.enum';
import { VehicleDamageStatusEnum } from '../enums/vehicle-damage-status.enum';
import { VehicleDamageTypeEnum } from '../enums/vehicle-damage-type.enum';

import { VehicleDamageLinksDto } from './vehicle-damage-links.dto';

/**
 * Vehicle damage DTO for lists
 */
@CaslSubject(AppSubjectEnum.VEHICLE_DAMAGE)
export class VehicleDamageListDto extends BaseDto {
	code!: string;
	status!: VehicleDamageStatusEnum;
	recordCategory!: VehicleDamageRecordCategoryEnum;
	reportedAt!: Date;
	type?: VehicleDamageTypeEnum | null;
	fault?: VehicleDamageFaultEnum | null;
	severity?: VehicleDamageSeverityEnum | null;
	policeReportFiled?: boolean | null;
	policeReportExternalReference?: string | null;
	estimatedCost?: number | null;
	vehicle?: VehicleListDto | null;
	rentalAgreement?: RentalAgreementListDto | null;
	thirdPartyContact?: ThirdPartyContactDto | null;
	thirdPartyInsurance?: VehicleInsuranceListDto | null;
	insuranceClaim?: VehicleInsuranceClaimListDto | null;
	tags?: TagListDto[] | null;
	links?: VehicleDamageLinksDto | null;

	computedTotalNet?: number | null;
	computedTotalTax?: number | null;
	computedTotalGross?: number | null;
}
